var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_48_950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#B7A2FF",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3293 72.3067C77.3293 73.276 76.7893 75.1427 75.576 76.168C75.3333 76.3547 75.0907 76.2493 75.1973 75.9773C75.5507 75.1133 76.3587 73.1147 75.98 72.6547C75.712 72.3053 74.6053 72.332 73.6613 72.412C73.2307 72.4667 72.852 72.492 72.5587 72.552C72.2867 72.5733 72.232 72.3347 72.504 72.148C72.8583 71.8981 73.2498 71.7055 73.664 71.5773C75.1973 71.1187 76.9693 71.3947 77.224 71.688C77.272 71.744 77.3293 71.9027 77.3293 72.3067ZM74.7667 74.0307C74.4161 74.301 74.0467 74.5461 73.6613 74.764C70.832 76.464 67.1667 77.3547 63.984 77.3547C58.86 77.3547 54.2773 75.4653 50.8 72.304C50.5013 72.0613 50.748 71.7093 51.0973 71.9C54.844 74.0867 59.4813 75.4093 64.2813 75.4093C67.3027 75.4093 70.5587 74.844 73.6613 73.628C73.8787 73.5467 74.1213 73.436 74.3333 73.3587C74.8227 73.1387 75.2533 73.6813 74.7667 74.0307ZM66.54 59.324C66.54 57.936 66.596 57.1187 66.136 56.4173C65.728 55.84 65.0253 55.4933 64.044 55.548C62.98 55.6067 61.8373 56.304 61.5467 57.5827C61.4893 57.876 61.3187 58.164 60.964 58.2267L57.7173 57.8133C57.4853 57.76 57.132 57.5827 57.248 57.1187C57.9453 53.4507 61.08 52.172 64.0453 52H64.7413C66.368 52 68.4587 52.4653 69.796 53.6853C71.4187 55.2 71.2453 57.2347 71.2453 59.4453V64.6813C71.2453 66.252 71.8827 66.948 72.5227 67.7667C72.696 68.0587 72.756 68.4027 72.464 68.64C71.624 69.3889 70.7719 70.1241 69.908 70.8453C69.6747 71.0227 69.256 71.0413 69.0947 70.9053C68.068 70.0453 67.8173 69.568 67.1813 68.6947C66.0747 69.856 65.1453 70.4973 64.04 70.8453C63.2628 71.0431 62.4633 71.1399 61.6613 71.1333C58.8747 71.1333 56.668 69.396 56.668 65.96C56.668 63.228 58.1213 61.3707 60.268 60.492C62.4147 59.612 65.5347 59.332 66.54 59.3267M65.904 66.2493C66.5973 65.0867 66.54 64.1347 66.54 62.0027C65.6707 62.0027 64.7987 62.0627 64.0453 62.24C62.652 62.644 61.5453 63.52 61.5453 65.38C61.5453 66.8333 62.3027 67.8227 63.58 67.8227C63.756 67.8227 63.9107 67.8027 64.044 67.7627C64.9373 67.5147 65.4947 67.0667 65.904 66.2493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_48_950",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_950",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717093 0 0 0 0 0.635577 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_48_950"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazon);
export default __webpack_public_path__ + "static/media/Amazon.c56f4d6cd389ef29cbaac0ad92842c0e.svg";
export { ForwardRef as ReactComponent };